<script setup lang="ts">
import LegacyApp from './LegacyApp.vue';
import CmsApp from './CmsApp.vue';
import ActivationApp from './ActivationApp.vue';
import CustomerLoginPage from './CustomerLoginPage.vue';
import LegalTermsPage from './LegalTermsPage.vue';
const cms=location.pathname.startsWith('/cms');
const owner=location.pathname.startsWith('/owner');
const activation=location.pathname.startsWith('/activate');
const customerLogin=/^\/tai-khoan\/?$/.test(location.pathname);
const legalTerms=/^\/(dieu-khoan-su-dung|dieu-khoan)\/?$/.test(location.pathname);
if(owner) location.replace(`/quan-ly-gian-hang/${location.search}`);
</script>
<template><ActivationApp v-if="activation"/><CmsApp v-else-if="cms"/><div v-else-if="owner"/><CustomerLoginPage v-else-if="customerLogin"/><LegalTermsPage v-else-if="legalTerms"/><LegacyApp v-else/></template>
